var React = require('react');

function IconLeadStageGoal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm2.18-14.4h1.92l2.4 4.364-2.4 4.363h-1.92l2.4-4.363-2.4-4.364zm-3.84 0h1.92l2.4 4.364-2.4 4.363H8.34l2.4-4.363L8.34 5.6zm-3.84 0h1.92l2.4 4.364-2.4 4.363H4.5l2.4-4.363L4.5 5.6z","fill":"#7A7370"}));
}

IconLeadStageGoal.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = IconLeadStageGoal;

IconLeadStageGoal.default = IconLeadStageGoal;
